import React, { useState, useEffect } from 'react';
import Hero from './components/Hero';
import Details from './components/Details';
import Venue from './components/Venue';
import RSVP from './components/RSVP';
import Footer from './components/Footer';
import LanguageSwitcher from './components/LanguageSwitcher';
import IntroAnimation from './components/IntroAnimation';
import { LanguageProvider } from './context/LanguageContext';
import { AnimatePresence, motion } from 'framer-motion';

function App() {
  const [showIntro, setShowIntro] = useState(true);

  return (
    <LanguageProvider>
      <div className="min-h-screen bg-stone-50 selection:bg-brand-accent selection:text-white overflow-x-hidden">
        <IntroAnimation onComplete={() => setShowIntro(false)} />
        
        <AnimatePresence>
          {!showIntro && (
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 1.5, ease: "easeOut" }}
            >
              <LanguageSwitcher />
              <main>
                <Hero />
                <Details />
                <Venue />
                <RSVP />
              </main>
              <Footer />
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </LanguageProvider>
  );
}

export default App;